/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, image, imageAlt, index, type, path, publishedDate, author }) {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        contentfulImages (name: {eq: "Social Sharing Default Image"}) {
          image {
              file {
                url
              }
              title
          }
      }
      }
    `
  )

  const metaDescription = description || data.site.siteMetadata.description
  const shareImage = image || data.contentfulImages.image.file.url
  const shareImageAlt = imageAlt || data.contentfulImages.image.title


  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${data.site.siteMetadata.title}`}
      meta={[
        // {
        //   httpEquiv: `Content-Security-Policy`,
        //   content: `block-all-mixed-content`,
        // },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: type || 'website',
        },
        {
          property: `fb:app_id`,
          content: `287572415945240`,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:image`,
          content: `https:${shareImage}`
        },
        {
          property: `og:image:alt`,
          content: shareImageAlt
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:site_name`,
          content: `Steph Sunshine`,
        },
        {
          property: `og:locale`,
          content: `en_US`,
        },
        {
          property: `article:author`,
          content: author || `Steph Sunshine`,
        },
        {
          property: `article:published_time`,
          content: publishedDate,
        },
        {
          property: `og:url`,
          content: `https://www.stephsunshine.com${path}`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:site`,
          content: `@msstephsunshine`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: `https:${shareImage}`,
        },
        {
          name: `twitter:image:alt`,
          content: shareImageAlt,
        },
        {
          name: `robots`,
          content: index || `index,follow`,
        },
        {
          name: "p:domain_verify",
          content: "686da0f28a44ac8ae2e90d20f8d82481",
        },{
          name: "facebook-domain-verification",
          content: "aq5j1ogevih5jhm2crs3q9xgtvlsqk",
        },
      ].concat(meta)}
    >
      <link rel="canonical" href={`https://www.stephsunshine.com${path}/`}></link>
      
      </Helmet>
      
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}



export default SEO
